export const GetRunningOrder = async (dataJson: any) => {
    const respone = await fetch("api/RunningOrder/GetRunningOrder", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataJson),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        return err;
      });
  
    return respone;//.filter((e: any) => e.IsActive === true);
  };